"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  delete props.display;
  delete props.wrap;
  delete props.row;
  delete props.column;
  delete props.alignItems;
  delete props.alignSelf;
  delete props.alignContent;
  delete props.justifyContent;
  delete props.flex;
  delete props.flexGrow;
  delete props.flexShrink;
  delete props.flexBasis;
  delete props.inline;
  delete props.wrap;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flex/lib/cleanup.js
// module id = 412
// module chunks = 0